const WORDS = ["Sites institucionais", "Landing pages", "Redesign", "Lojas virtuais", "Identidade digital", "Experiência de usuário"];

export const Marquee = () => {
  const row = WORDS.flatMap((w, i) => [
    <span key={w} className={i % 2 ? "outline-text font-display font-semibold" : "font-serif italic text-[#F5F3EE]"}>{w}</span>,
    <span key={`${w}-d`} className="text-gold text-[0.5em] mx-6 sm:mx-10">✦</span>,
  ]);
  return (
    <div data-testid="marquee" className="relative border-y border-white/5 py-6 sm:py-8 overflow-hidden select-none" aria-hidden="true">
      <div className="marquee-track flex w-max whitespace-nowrap items-center text-4xl sm:text-6xl lg:text-7xl tracking-[-0.02em]">
        <div className="flex items-center pr-10">{row}</div>
        <div className="flex items-center pr-10">{row}</div>
      </div>
    </div>
  );
};
